import { create } from 'zustand';
import { api } from '../services/api';

export const useAuthStore = create((set, get) => ({
  admin: null,
  token: null,
  isAuthenticated: false,
  isLoading: true,

  // Инициализация при загрузке
  init: async () => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      api.setToken(token);
      try {
        const data = await api.checkAuth();
        if (data.authenticated) {
          set({ admin: data.admin, token, isAuthenticated: true, isLoading: false });
          return true;
        }
      } catch (error) {
        console.error('Auth check failed:', error);
      }
    }
    set({ isLoading: false });
    return false;
  },

  // Вход
  login: async (username, password) => {
    set({ isLoading: true });
    try {
      const data = await api.login(username, password);
      set({
        admin: data.admin,
        token: data.token,
        isAuthenticated: true,
        isLoading: false,
      });
      return { success: true };
    } catch (error) {
      set({ isLoading: false });
      return { success: false, error: error.message };
    }
  },

  // Выход
  logout: async () => {
    try {
      await api.logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
    set({ admin: null, token: null, isAuthenticated: false });
  },

  // Очистка состояния
  clear: () => {
    set({ admin: null, token: null, isAuthenticated: false, isLoading: false });
  },
}));
